function priceFormat(str) {
    return str.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
}

window.showTestDrivePopup = function(model_id) {
    $.fancybox.open({
        src: '#test-drive-popup',
        type: 'inline',
        opts: {
            beforeShow: function (instance, slide) {
                $('.popup__model-id').val(model_id);
            }
        }
    });
}

window.showTradeInPopup = function(version_id) {
    $.fancybox.open({
        src: '#trade-in-popup',
        type: 'inline',
        opts: {
            beforeShow: function (instance, slide) {
                $('.popup__version_id').val(version_id);
            }
        }
    });
}

window.showPricePopup = function(price_range, price_old, price_new, brand, model_text, equipment, status) {
    $.fancybox.open({
        src: '#show-price-popup',
        type: 'inline',
        opts: {
            beforeShow: function (instance, slide) {
                if (status === 'new') {
                    $('#show-price-popup-prices').attr('data-range', price_range);
                    $('#show-price-popup-prices').attr('data-price-new', price_new);
                    $('#show-price-popup-prices').attr('data-price-old',price_old);
                    console.log($('.js-check-credit').attr('checked'))
                    console.log($('.js-check-tradein').attr('checked'))
                    console.log($('.js-check-util').attr('checked'))
                    // if ($('.js-check-credit').attr('checked') !== 'checked') {
                    //     $('.js-check-credit').trigger('click')
                    //     // $('.js-check-credit').prop('checked', true);
                    // }
                    // if ($('.js-check-tradein').attr('checked') !== 'checked') {
                    //     $('.js-check-tradein').trigger('click')
                    //     // $('.js-check-tradein').prop('checked', true);
                    // }
                    // if ($('.js-check-util').attr('checked') !== 'checked') {
                    //     $('.js-check-util').trigger('click')
                    //     // $('.js-check-util').trigger('change')
                    //     // $('.js-check-util').prop('checked', true);
                    // }
                    // $('.js-check-credit').closest(".checkbox").toggleClass('changed');
                    // $('.js-check-tradein').closest(".checkbox").toggleClass('changed');
                    // $('.js-check-util').closest(".checkbox").toggleClass('changed');

                    if (!$('.js-check-credit').closest(".checkbox").hasClass('changed')) {
                        $('.js-check-credit').trigger('click')
                        console.log(1);
                        // $('.js-check-credit').closest(".checkbox").toggleClass('changed');
                        $('.js-check-credit').prop('checked', true);
                    }

                    if (!$('.js-check-tradein').closest(".checkbox").hasClass('changed')) {
                        $('.js-check-tradein').trigger('click')
                        console.log(2);
                        // $('.js-check-tradein').closest(".checkbox").toggleClass('changed');
                        $('.js-check-tradein').prop('checked', true);
                    }

                    if (!$('.js-check-util').closest(".checkbox").hasClass('changed')) {
                        $('.js-check-util').trigger('click')
                        console.log(3);
                        // $('.js-check-util').closest(".checkbox").toggleClass('changed');
                        $('.js-check-util').prop('checked', true);
                    }
                }

                $('#minimal-price').text(priceFormat(price_new));
                $('#text-price-model').text(priceFormat(model_text));
                $('#equipment-text').text(priceFormat(equipment));
                $('#range-price-finance').text(priceFormat(price_range));
                $('#brand-finance-price').text(brand);
            },
        }
    });
}

window.showGosAppPopup = function(model_id) {
    $.fancybox.open({
        src: '#gosprogramm-popup',
        type: 'inline',
        opts: {
            beforeShow: function (instance, slide) {
                $('.popup__model_id').val(model_id);
            }
        }
    });
}

window.showCreditPopup = function(version_id, monthly) {
    $.fancybox.open({
        src: '#credit-popup',
        type: 'inline',
        opts: {
            beforeShow: function (instance, slide) {
                $('.popup__version_id').val(version_id);
                $('.popup__caption .monthly').text(monthly + ' руб/мес.');
            }
        }
    });
}

window.showReservePopup = function(version_id,  car_image)
{
    $.fancybox.open({
        src: '#reserve-popup',
        type : 'inline',
        opts : {
            beforeShow : function( instance, slide ) {
                $('#reserve-popup .popup__version_id').text(version_id);
                $('#reserve-popup .popup__top-img').attr('src', car_image);
            }
        }
    });
}

window.showInstallmentPopup = function(car_id) {
    $.fancybox.open({
        src: '#installment-popup',
        type: 'inline',
        opts: {
            beforeShow: function (instance, slide) {
                $('.popup__car-id').val(car_id);
            }
        }
    });
}
